import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Empty, Flex, Modal, Skeleton } from 'antd';
import { ClockCircleOutlined } from '@ant-design/icons';
import { useGetClientInsuranceHistory } from 'api/clients/use-get-client-insurance-history';
import { ClientInsuranceHistoryItem } from 'components/clients/client-insurance/components/client-insurance-history-item';
import styles from './client-insurance-history.module.scss';
import type { IClientInsuranceHistoryProps } from './types';

export const ClientInsuranceHistory = (props: IClientInsuranceHistoryProps) => {
  const { clientId } = props;
  const { t } = useTranslation('client');
  const [isOpen, setIsOpen] = useState(false);

  const { data: history = [], isLoading } = useGetClientInsuranceHistory({ clientId, enabled: isOpen });

  const renderContent = () => {
    if (isLoading) {
      return <Skeleton paragraph={{ rows: 4 }} active />;
    }

    if (!history.length) {
      return <Empty description={t('insurance_history_empty')} />;
    }

    return (
      <Flex className={styles.list} gap={8} vertical>
        {history.map((insurance) => (
          <ClientInsuranceHistoryItem key={insurance.id} clientId={clientId} insurance={insurance} />
        ))}
      </Flex>
    );
  };

  return (
    <>
      <Button className={styles.button} type='text' icon={<ClockCircleOutlined />} onClick={() => setIsOpen(true)}>
        {t('insurance_view_history')}
      </Button>
      <Modal
        rootClassName={styles.modal}
        title={t('insurance_history')}
        open={isOpen}
        width={460}
        footer={null}
        onCancel={() => setIsOpen(false)}>
        {renderContent()}
      </Modal>
    </>
  );
};
